import React from "react";

const viraj_nalbalwar = () => {
  return (
    <div>
      <h1>Viraj Nalbalwar</h1>

      <h3>
        <em>Computer Engineering, Batch of 27'</em>
        <br />
        <hr />
      </h3>

      <p>
        <strong>CSI Internship Diaries 2025</strong>
      </p>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?
      </p>

      <ul>
        <li>
          The shortlisting was based on the Online Assessment (OA) round.{" "}
        </li>
        <li>
          It consisted of two coding questions, generally from medium to hard
          difficulty level.{" "}
        </li>
        <li>
          OA round was the only shortlisting criteria in the initial stage, then
          candidates clearing it moved ahead to the Code For Change hackathon,
          which was the next step in the process.
        </li>
      </ul>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The timeline went like this:
      </p>

      <ul>
        <li>OA Round - 11th August </li>
        <li>Shortlisting Announcement - 16th August </li>
        <li>Hackathon - 25th August</li>
      </ul>

      <p>
        There were no traditional interview rounds (like Technical or HR). It
        was a straightforward path - OA -&gt; Hackathon -&gt; Internship
        <br />
        After the hackathon, the final results were declared in about two weeks.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        As mentioned, the OA round had two coding problems - one was tree +
        dynamic programming based which involves LCA and maximum subarray logic,
        while the other was a simulation problem using queues and event
        handling. Both were of medium to hard difficulty.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        After the OA round, 11 candidates were shortlisted for the Mastercard
        Code For Change 2025 Hackathon.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The shortlisting results came out on 16th August, and the hackathon was
        held on 25th August, so there was about a one-week gap.
        <br />
        During that period, I focused on:
      </p>

      <ul>
        <li>Creating prototypes for possible project ideas </li>
        <li>
          Reviewed past hackathon themes and understanding their problem
          statements{" "}
        </li>
        <li>Practicing the tech stack I planned to use</li>
      </ul>

      <p>
        Since it was a 12-hour hackathon, time and team management were crucial,
        we had to build the project, prepare a demo, a presentation all within
        that timeframe.
      </p>

      <p>
        Every team had 8 members from different colleges, and the teams were
        formed by the Mastercard team itself. We got introduced to our teammates
        a week before the hackathon. Each team also had a dedicated mentor who
        guided us throughout the event, they did check in about our tech stack,
        problem solving approach, and progress.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        For Mastercard’s internship hiring, there were no interview rounds.
        <br />
        The entire selection process was like:
        <br />
        Online Assessment -> Hackathon -&gt; Internship :)
        <br />
        After the hackathon, 8 candidates were selected as interns.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        Since the hackathon replaced traditional interviews, I mainly focused on
        Web development, specifically frontend (React, Nextjs) and styling
        frameworks, for backend and database, I practiced Nextjs APIs and
        MongoDB for integration. I also explored AI chatbots and deployment
        using AWS and Vercel.
      </p>

      <p>
        During the hackathon, our mentor interacted with us regularly, sometimes
        asking technical questions, sometimes just casual check-ins. They often
        provided feedback on our progress and guided us if we were stuck.
        Overall, it was a very friendly, learning environment.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        For DSA, I followed Striver’s A2Z Sheet and Love Babbar’s Sheet, and
        practiced regularly on LeetCode and GeeksforGeeks.
        <br />
        For the hackathon, I referred to documentation of Nextjs, MongoDB, and
        quick UI/UX tutorials and some deployment strategies.
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Practice medium to hard-level problems, specially those involving trees,
        DP, etc. Also write clean, optimized and well commented code, sometimes
        even a partially correct but well explained approach creates a good
        impression.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        In my case, since there wasn’t a traditional interview, there weren’t
        direct questions from my resume. However, during the hackathon, the
        mentors casually asked about our past projects.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Yes, don’t treat it like a typical internship process. Mastercard’s Code
        For Change is more about how you think, build and collaborate than just
        how much theory you know.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Keep your basics strong, but also learn to apply them practically, build
        small projects, be curious, stay consistent and most importantly enjoy
        the process :)
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Phone No :</strong> 9763345872
        <br />
        <strong>Email :</strong> <a href="mailto:nalbalwarvs24.comp@coeptech.ac.in">nalbalwarvs24.comp@coeptech.ac.in</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/viraj-nalbalwar-7b7245244/">
          Viraj Nalbalwar
        </a>
      </p>

      <hr />
    </div>
  );
};

export default viraj_nalbalwar;
